import { Button as ButtonAntd } from 'antd';
import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  margin-bottom: 24px;

  .d-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .container_payment_card {
    min-height: 120px;
    max-width: ${(props) => {
      return props.block ? 'unset' : '512px';
    }};
    white-space: nowrap;
    border-radius: 12px;
    position: relative;
    background-image: ${(props) => {
      return `url(${props.backgroundImage})`;
    }};
    background-size: cover;
    background-position: center center;
    padding: 18px 21px 24px;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .container_payment_card_header {
    margin-bottom: 20px;
    color: ${color.grey5};
    .container_payment_card_header_badge {
      background: rgba(0, 0, 0, 0.15);
      border-radius: 12px;
      padding: 0 12px;
      height: 34px;
    }
  }

  .container_payment_card_body {
    color: ${color.grey5};
    div:first-child {
      max-width: 80%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .container_payment_card_unlicensed {
    display: flex;
    align-items: center;
    column-gap: 20px;
    min-height: 120px;
    border-radius: 12px;
    background: #d9e3e8;
    padding: 18px 21px 24px;
    overflow: hidden;
    max-width: ${(props) => {
      return props.block ? 'unset' : '512px';
    }};

    .component_unlicensed_image {
      img {
        opacity: 0.6;
        mix-blend-mode: luminosity;
      }
    }
    .component_unlicensed_text {
      > div:first-child {
        color: ${color.black2};
      }
      > div:last-child {
        color: ${color.black3};
      }
    }
  }
`;

export default Wrapper;

export const ButtonPayment = styled(ButtonAntd)`
  border-radius: 12px;
  padding: 0 28px;
  height: 46px;
  font-size: 16px;
  font-weight: 600;
  text-shadow: none;
  color: ${color.black1};
  margin-top: 16px;
  :hover,
  :focus,
  :active {
    color: ${color.black3};
    background-color: ${color.grey5};
    border-color: ${color.grey5};
  }
`;
